import { ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import React, { useCallback, useEffect, useState } from 'react'
import { ExpandAddView } from '../../components/ExpandAddView'
import { ListNew } from '../../components/ListNew'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { AddNewEntity } from './AddNewEntity'
import { statusData, subtypeData, typeData } from './formData'

const EntityMaster = () => {
  const [isExpand, setIsExpand] = useState(false)
  const navigation: any = useNavigation()

  const { getAllEntities, accessConfig, config } = useStores((store) => ({
    getAllEntities: store.entityMaster.getAllEntities,
    accessConfig: store.user.getAccessConfig(['entity_config', 'entity_master']),
    config: store.user.accessConfig,
  }))

  const [getAllEntitiesApi, getAllEntitiesHandler] = useLazyApiData(getAllEntities)
  const searchFormRef = React.useRef(null)

  useEffect(() => {
    if (isAccessible(accessConfig, 'fetch')) {
      getAllEntitiesApi(searchFormRef?.current?.getValues(), { page: 1, size: 10 })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAllEntitiesApi, config])

  const onUpdate = () => {
    setIsExpand(false)
    getAllEntitiesApi({}, { page: 1, size: 10 })
  }

  const fetchDataFromServer = useCallback(
    (data, paginationInfo) => getAllEntitiesApi(data, paginationInfo),
    [getAllEntitiesApi],
  )

  const keyExtractor = (item: any): string => {
    return item.id
  }

  const renderList = () => {
    return (
      <ListNew
        listTitle={'Processor List'}
        searchData={SEARCH_FILTERS as any}
        searchFormRef={searchFormRef}
        updatedPaginationInfo={{
          ...(getAllEntitiesHandler?.data?.pageNo !== undefined && { page: getAllEntitiesHandler?.data?.pageNo }),
          ...(getAllEntitiesHandler?.data?.totalElements !== undefined && {
            total: getAllEntitiesHandler?.data?.totalElements,
          }),
        }}
        isSearchButtonLoading={getAllEntitiesHandler?.state === 'pending'}
        apiHandler={getAllEntitiesHandler}
        fetchDataFromServer={fetchDataFromServer}
        data={getAllEntitiesHandler?.data?.content}
        onRowItemClick={({ item }) => {
          navigation.navigate('editEntity', { entityData: item })
        }}
        keyExtractor={keyExtractor}
        headTitle={headTitles}
        sizeConfig={[1, 1, 1, 0.9, 1.2, 0.9, 1, 1, 1, 1, 1]}
        type={'SCROLLABLE'}
        columnsWidth={getCustomColumnWidth}
        cellTextStyle={{ fontSize: 12, fontFamily: 'jiotype-medium' }}
        headerTextStyle={{ fontSize: 12, fontFamily: 'jioType-bold', textTransform: 'capitalize' }}
      />
    )
  }

  return (
    <>
      <Text
        testID={'entity-page-Title'}
        title={'Processor Information'}
        fontSize={28}
        fontWeight={'600'}
        color={'#5a5c69' as ColorOptions}
      />
      <Spacer direction="vertical" size={24} />
      {isAccessible(accessConfig, 'add') && (
        <ExpandAddView
          children={<AddNewEntity onUpdate={onUpdate} onClose={() => setModal(false)} />}
          title={'Add New Processor'}
          isExpand={isExpand}
          setIsExpand={setIsExpand}
          testID={'entity-config-expandview'}
        />
      )}
      <Spacer direction="vertical" size={24} />
      {isAccessible(accessConfig, 'fetch') && renderList()}
    </>
  )
}

const headTitles = [
  { ID: 'Processor ID' },
  { name: 'Name' },
  { type: 'Type' },
  { subType: 'Sub Type' },
  { status: 'Status' },
  { metadata: 'MetaData' },
  { createdAt: 'Created At' },
  { createdBy: 'Created By' },
  { createdFrom: 'Created From' },
  { updatedAt: 'Updated At' },
  { updatedBy: 'Updated By' },
  { updatedFrom: 'Updated From' },
]

const SEARCH_FILTERS = [
  [
    { key: 'id', type: 'string', placeHolder: 'Processor ID' },
    { key: 'name', type: 'string', placeHolder: 'Name' },
  ],
  [
    { key: 'type', type: 'dropdown', placeHolder: 'Type', data: typeData },
    { key: 'subType', type: 'dropdown', placeHolder: 'subType', data: subtypeData },
    {
      key: 'entityStatus',
      type: 'dropdown',
      placeHolder: 'Status',
      data: statusData,
    },
  ],
]

export default EntityMaster

export const getCustomColumnWidth = () => 200
